import { req } from 'react-reqq-lite';

import { withAclReq } from 'modules/partial/hooks';
import { transformPartner } from 'modules/admin/supermarket-place/partners/transformers';

import * as c from './constant';

export const getPartnerProfile = (params, cb) => {
  req.get(
    withAclReq(
      () => ({
        ADMIN: {
          url: ``,
        },
        PARTNER: {
          url: '/v1/partner/me/profile',
        },
        MERCHANT: {
          url: ``,
        },
      }),
      {
        key: c.GET_PARTNER_PROFILE,
        transform: ({ data, included }) => transformPartner(data, included),
        onSuccess: () => cb?.(),
      }
    )
  );
};
